/**
 * 选优惠券
 */
export default [
  {
    path: '/coupon/orderCoupon',
    name: 'OrderCoupon',
    component: (resolve) => require(['@/views/coupon/orderCoupon'], resolve),
    meta: {
      title: '优惠券',
      keepAlive: false // /此组件不需要缓存
    }
  },
  {
    path: '/coupon/myCouponList',
    name: 'MyCouponList',
    component: (resolve) => require(['@/views/coupon/myCouponList'], resolve),
    meta: {
      title: '优惠券',
      keepAlive: false // /此组件不需要缓存
    }
  },
  {
    path: '/coupon/couponProductList',
    name: 'CouponProductList',
    component: (resolve) => require(['@/views/coupon/couponProductList'], resolve),
    meta: {
      title: '可用范围',
      keepAlive: false // /此组件不需要缓存
    }
  }
];




// WEBPACK FOOTER //
// ./src/router/modules/coupon.js